export default __webpack_public_path__ + "static/media/regulatory--end-of-no-horn--g1.38488514.png";